export const ABORT_ERROR = 'AbortError'
